import React from 'react';
import './grid.scss';

export const Grid = ({
    children,
    className,
    fluid = true,
}) => {


    return (
        <div className={`bsw-grid ${fluid ? 'container-fluid' : 'container'} ${className ? className : ''}`}>
            {children}
        </div>
    )
}